"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createSchemaListPage = exports.SchemaListPage = void 0;
const react_1 = __importStar(require("react"));
const components_1 = require("utils/components");
const converter_1 = require("./converter");
const react_router_dom_1 = require("react-router-dom");
const SchemaFormPage_1 = require("../SchemaFormPage");
const Spinner_1 = __importDefault(require("react-bootstrap/Spinner"));
const standard_1 = require("react-hook-schema/standard");
const csvUtil_1 = require("./csvUtil");
const XLSX = __importStar(require("xlsx"));
const parseCsv_1 = require("./parseCsv");
const dayjs_1 = __importDefault(require("dayjs"));
const auth_1 = require("common/auth");
exports.SchemaListPage = react_1.default.memo(function SchemaListPage({ schemaComponents, parameter, list, header, loading, hasMore, refresher, fetching, filterComponent, reload, rowActions, }) {
    const { role } = (0, auth_1.useAdminAuthentication)();
    const isMaster = role === "master";
    const { schema, title, edit, create, download, upload, setRange, tooltip } = parameter;
    const editPath = edit.path;
    const createPath = create === null || create === void 0 ? void 0 : create.path;
    const modalForm = (0, SchemaFormPage_1.useModalForm)();
    const [downloadUrl, setDownloadUrl] = (0, react_1.useState)(null);
    const [fileFormat, setFileFormat] = (0, react_1.useState)("xlsx");
    const toost = (0, standard_1.useToost)();
    (0, react_1.useEffect)(() => {
        if (!downloadUrl)
            return;
        const currentDate = (0, dayjs_1.default)().format("YYYYMMDDHHmmss");
        const downloadFilename = (download === null || download === void 0 ? void 0 : download.filename)
            ? `${download === null || download === void 0 ? void 0 : download.filename}-${currentDate}.${fileFormat}`
            : `${downloadUrl.split("/").pop()}.${fileFormat}`;
        const _a = document.createElement("a");
        _a.href = downloadUrl;
        _a.download = downloadFilename;
        _a.click();
        setDownloadUrl(null);
        setTimeout(() => {
            URL.revokeObjectURL(downloadUrl);
        }, 1000);
    }, [downloadUrl]);
    const downloadHandler = (0, react_1.useCallback)((e) => __awaiter(this, void 0, void 0, function* () {
        e.preventDefault();
        const result = yield modalForm({
            schemaComponents,
            params: {
                title: "ダウンロード",
                subtitle: "ダウンロードボタンを押すと、ファイルがダウンロードされます。",
                edit: {
                    title: "ダウンロード",
                },
                schema: {
                    schemaType: "object",
                    properties: [
                        ...(isMaster
                            ? [
                                {
                                    title: "出力形式",
                                    propertyName: "fileFormat",
                                    schema: {
                                        schemaType: "selector",
                                        required: true,
                                        options: [
                                            {
                                                title: "Excel",
                                                value: "xlsx",
                                            },
                                            {
                                                title: "CSV",
                                                value: "csv",
                                            },
                                        ],
                                    },
                                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
                                },
                            ]
                            : []),
                    ],
                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
                },
            },
            value: {},
        });
        console.log("downloadHandler", result);
        if (!result)
            return;
        const { fileFormat: _fileFormat, isConvert, isMinHeader: _isMinHeader, forceUseRealFields: _forceUseRealFields, } = result;
        const fileFormat = isMaster ? _fileFormat : "xlsx"; // クライアント権限の場合、ファイル形式はxlsx固定
        // クライアント権限の場合、変換オプションは固定で有効にする
        const isJoinMaster = isMaster ? isConvert : true; // 表示名を追加する
        const isExpandMultipleSelector = isMaster ? isConvert : true; // 複数選択を展開する
        const isConvertSelector = isMaster ? isConvert : true; // 単数選択を変換する
        const isConvertId = isMaster ? isConvert : true; // IDを変換する
        const isMinHeader = isMaster ? _isMinHeader : true;
        const forceUseRealFields = isMaster ? _forceUseRealFields : false;
        const _list = ((download === null || download === void 0 ? void 0 : download.handler) ? yield (download === null || download === void 0 ? void 0 : download.handler()) : list) || [];
        const downloadSchema = typeof (download === null || download === void 0 ? void 0 : download.schema) === "function"
            ? download === null || download === void 0 ? void 0 : download.schema(forceUseRealFields)
            : download === null || download === void 0 ? void 0 : download.schema;
        const _schema = downloadSchema || schema;
        const bom = new Uint8Array([0xef, 0xbb, 0xbf]);
        console.log("downloadHandler", _list, _schema);
        // 中間ファイルを作成する
        const dataArray = yield (0, csvUtil_1.arrayToXlsx)(_list || [], (downloadSchema || schema), fileFormat === "csv", isJoinMaster, isExpandMultipleSelector, isConvertSelector, isConvertId, isMinHeader);
        // ファイル生成（excelとcsvで分岐）
        let blob = null;
        const workSheet = XLSX.utils.aoa_to_sheet(dataArray);
        if (fileFormat === "xlsx") {
            const workbook = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(workbook, workSheet, "Sheet1");
            const excelUnit8Array = XLSX.write(workbook, { type: "array" });
            blob = new Blob([excelUnit8Array], {
                type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            });
        }
        else if (fileFormat === "csv") {
            const csv = XLSX.utils.sheet_to_csv(workSheet);
            blob = new Blob([bom, csv], { type: "text/csv" });
        }
        if (blob === null) {
            console.warn("blob is null");
            return;
        }
        setFileFormat(fileFormat);
        const url = URL.createObjectURL(blob);
        setDownloadUrl(url);
    }), [list]);
    const uploadHandler = (0, react_1.useCallback)((e) => __awaiter(this, void 0, void 0, function* () {
        e.preventDefault();
        const result = yield modalForm({
            schemaComponents,
            params: {
                title: "アップロード",
                edit: {
                    title: "アップロード",
                },
                schema: {
                    schemaType: "object",
                    properties: [
                        {
                            title: "CSVファイル",
                            propertyName: "uploadCsvData",
                            schema: {
                                schemaType: "multilineText",
                                required: true,
                            },
                        },
                    ],
                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
                },
            },
            value: {},
        });
        if (!result)
            return;
        try {
            const parsed = (0, parseCsv_1.parseCsv)(result.uploadCsvData, upload === null || upload === void 0 ? void 0 : upload.schema);
            if (upload === null || upload === void 0 ? void 0 : upload.bulkHandler) {
                yield (upload === null || upload === void 0 ? void 0 : upload.bulkHandler(parsed));
            }
            else {
                yield Promise.all(parsed.map((value) => { var _b; return (_b = upload === null || upload === void 0 ? void 0 : upload.handler) === null || _b === void 0 ? void 0 : _b.call(upload, value); }));
            }
            toost({
                message: "アップロードが完了しました",
                duration: 10000,
            });
        }
        catch (e) {
            if (e instanceof Error && e.name === "ParseError") {
                toost({
                    message: e.message,
                    duration: 10000,
                });
                return;
            }
            throw e;
        }
        reload === null || reload === void 0 ? void 0 : reload();
    }), [list]);
    const columns = (0, react_1.useMemo)(() => {
        return [
            {
                Header: "",
                id: "actions",
                accessor: "actions",
                Cell: ({ row }) => {
                    return (react_1.default.createElement(react_1.default.Fragment, null,
                        rowActions && rowActions(row.original),
                        editPath(row.original) && (react_1.default.createElement(react_router_dom_1.Link, { to: editPath(row.original) },
                            react_1.default.createElement(components_1.Button, { size: "sm", endIcon: "chevron-right" }, "\u78BA\u8A8D")))));
                },
                disableSortBy: true,
            },
            ...(0, converter_1.propertiesToColumns)(schemaComponents, schema.properties),
        ];
    }, [schema.properties, editPath]);
    const navigate = (0, react_router_dom_1.useNavigate)();
    // const performDownload = useDownload();
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(components_1.PageHeader, { title: title, breadCrumbConfigs: parameter.breadcrumbConfigs },
            react_1.default.createElement("div", { className: "d-flex gap-1" },
                !(create === null || create === void 0 ? void 0 : create.isDisabled) && createPath && (react_1.default.createElement(react_router_dom_1.Link, { to: createPath() },
                    react_1.default.createElement(components_1.Button, { variant: "primary", "data-tooltip-id": "tooltip", "data-tooltip-content": "\u65B0\u898F\u4F5C\u6210" },
                        react_1.default.createElement("span", { className: "mdi mdi-plus" })))),
                !loading && !(download === null || download === void 0 ? void 0 : download.isDisabled) && isMaster && (react_1.default.createElement(components_1.Button, { onClick: downloadHandler, variant: "primary", "data-tooltip-id": "tooltip", "data-tooltip-content": "\u30C0\u30A6\u30F3\u30ED\u30FC\u30C9" },
                    react_1.default.createElement("span", { className: "mdi mdi-download" }))),
                !loading && upload && !(upload === null || upload === void 0 ? void 0 : upload.isDisabled) && (react_1.default.createElement(react_1.default.Fragment, null,
                    react_1.default.createElement(components_1.Button, { onClick: uploadHandler, variant: "primary", "data-tooltip-id": "tooltip", "data-tooltip-content": "\u30A2\u30C3\u30D7\u30ED\u30FC\u30C9" },
                        react_1.default.createElement("span", { className: "mdi mdi-upload" })))),
                !loading && tooltip && (react_1.default.createElement(react_1.default.Fragment, null,
                    react_1.default.createElement(components_1.Button, { variant: "primary", "data-tooltip-id": "tooltip-click", "data-tooltip-html": tooltip && `<div class="tooltip-content">${tooltip}</div>`, style: {
                            borderRadius: "50%",
                            width: "26px",
                            height: "26px",
                            padding: "0",
                        } },
                        react_1.default.createElement("span", { className: "mdi mdi-information-variant" })))),
                parameter.history && (react_1.default.createElement(components_1.Button, { style: { marginLeft: "5px" }, variant: "primary", onClick: () => __awaiter(this, void 0, void 0, function* () {
                        var _b;
                        navigate(((_b = parameter.history) === null || _b === void 0 ? void 0 : _b.path) || "");
                    }), "data-tooltip-id": "tooltip", "data-tooltip-content": "\u5C65\u6B74" },
                    react_1.default.createElement("i", { className: "mdi mdi-history" }))))),
        react_1.default.createElement("section", { style: { padding: "20px" } }, loading || !list ? (react_1.default.createElement("div", { style: { padding: "20px" } },
            react_1.default.createElement(Spinner_1.default, { animation: "border", role: "status" },
                react_1.default.createElement("span", { className: "visually-hidden" }, "Loading...")))) : (react_1.default.createElement("div", { className: "" },
            header,
            react_1.default.createElement("div", { className: "b-table" },
                react_1.default.createElement(components_1.Table, { columns: columns, data: list, hasMore: hasMore, fetching: fetching, onSetRange: setRange, refresher: refresher, filterComponent: filterComponent })))))));
});
const createSchemaListPage = (schemaComponents) => {
    return (props) => react_1.default.createElement(exports.SchemaListPage, Object.assign({}, props, { schemaComponents: schemaComponents }));
};
exports.createSchemaListPage = createSchemaListPage;
